import { Ability } from "@casl/ability";

/**
 * Create the ability instance.
 *
 * It's a singleton that will be used to set and check what actions user is
 * capable of doing in the application.
 */
export default new Ability([]);
